<template>
  <chart-card title="Histórico de faturamento" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-currency />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { colors } from '@/config/colors.js'
import * as helpers from '@/config/helpers.js'

export default {
  components: {
    ChartCard,
  },
  props: {
    listaMensal: [Array, Object],
    listaSemanal: [Array, Object],
    listaDiario: [Array, Object],
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    filterType: 'mensal',
  }),
  computed: {
    faturamento() {
      if (this.filterType === 'mensal') return this.faturamentoMensal
      if (this.filterType === 'semanal') return this.faturamentoSemanal
      if (this.filterType === 'diario') return this.faturamentoDiario
      return null
    },
    faturamentoMensal() {
      return helpers.agrupamentoMensal(this.listaMensal, 'VAL_FATURAMENTO')
    },
    faturamentoSemanal() {
      return helpers.agrupamentoSemanal(this.listaSemanal, 'VAL_FATURAMENTO')
    },
    faturamentoDiario() {
      return helpers.agrupamentoDiario(this.listaDiario, 'VAL_FATURAMENTO')
    },
    chartData() {
      return {
        labels: [...this.faturamento.map((object) => object.data)],
        datasets: [
          {
            label: 'Faturamento',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.faturamento.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
}
</script>
